'use client';

import { LazyMotion } from 'motion/react';
import { FC, PropsWithChildren } from 'react';

export const LazyMotionWrapper: FC<PropsWithChildren> = ({ children }) => (
  <LazyMotion features={async () => (await import('./partialFramerMotionFeatures')).default} strict>
    {children}
  </LazyMotion>
);
